// A lively lesson header: animated gradient + sheen sweep + drifting gold particles.
export default function LessonHero({ title, subtitle = "Let's walk through this step together." }) {
  const reduce = typeof window !== 'undefined' && window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const particles = Array.from({ length: 9 }, (_, i) => ({
    id: i,
    left: 8 + i * 10 + (i % 2 ? 3 : 0),
    size: 4 + (i % 3) * 3,
    dur: 4 + (i % 4),
    delay: (i * 0.5) % 4,
  }));

  return (
    <div className="lesson-hero" style={{ display: 'flex', alignItems: 'flex-end', gap: 16, borderRadius: 12, padding: '14px 20px', marginBottom: 18, minHeight: 96 }}>
      {!reduce && particles.map(p => (
        <span key={p.id} className="hero-particle"
          style={{ left: p.left + '%', width: p.size, height: p.size, animationDuration: p.dur + 's', animationDelay: p.delay + 's' }} />
      ))}

      <div style={{ color: '#fff', position: 'relative', zIndex: 1, paddingBottom: 6 }}>
        <div className={reduce ? '' : 'hero-title'} style={{ fontWeight: 800, fontSize: 17 }}>{title}</div>
        <div style={{ fontSize: 13, opacity: 0.88 }}>{subtitle}</div>
      </div>
    </div>
  );
}
